module.exports = __webpack_public_path__ + "static/img/new-19.be62f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-19.png
// module id = xzM3
// module chunks = 0